export default [
  {
    path: '/v1/admin-dashboard',
    name: 'v1_admin_dashboard',
    component: () => import('@/views/v1/modules/skeleton/admin/Dashboard.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v1/userss',
    name: 'v1_userss',
    component: () => import('@/views/v1/modules/skeleton/admin/Users.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
]
